var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "fill-height": "",
                "justify-start": "",
                row: "",
                wrap: ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c(
                    "v-subheader",
                    { staticClass: "pl-0 mt-0 pt-0" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "ml-0": "", column: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("h1", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.lblSetting.contactInformations)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "greyDark",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "primary--text mt-3",
                      attrs: { "text-xs-center": "", row: "" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs2: "", "mr-4": "", "pl-2": "" } },
                        [
                          _c(
                            "v-avatar",
                            {
                              staticClass: "mousechange profile--avatar",
                              staticStyle: { overflow: "hidden" },
                              attrs: { color: "greyLighter" },
                              on: {
                                click: _vm.handleClickPicture,
                                mouseover: _vm.handleImageMouseOver,
                                mouseleave: _vm.handleImageMouseLeave
                              }
                            },
                            [
                              _vm.file !== null
                                ? _c("img", {
                                    attrs: { src: _vm.file.url, alt: "avatar" }
                                  })
                                : _vm.userInfo.my_picture
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.userInfo.my_picture,
                                      alt: "avatar"
                                    }
                                  })
                                : _c(
                                    "v-icon",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.hoverImg,
                                          expression: "!hoverImg"
                                        }
                                      ],
                                      attrs: { large: "", alt: "avatar" }
                                    },
                                    [_vm._v("icon-tenant")]
                                  ),
                              _vm._v(" "),
                              _vm.loadUpdateImage
                                ? _c("v-progress-circular", {
                                    staticStyle: { position: "absolute" },
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hoverImg
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "grey darken-2",
                                      staticStyle: {
                                        position: "absolute",
                                        opacity: ".5",
                                        width: "100%",
                                        height: "90px"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            large: "",
                                            alt: "edit picture",
                                            color: "turquoise"
                                          }
                                        },
                                        [_vm._v("edit")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$route.meta["profile_signature"]
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2 white--text",
                                  attrs: {
                                    medium: "",
                                    fab: "",
                                    color: "primary"
                                  },
                                  on: { click: _vm.handleUpdateSignature }
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("icon-signature")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs8: "" } },
                        [
                          !_vm.isUserUpdateAction
                            ? _c(
                                "v-card",
                                {
                                  ref: "user-infos-card",
                                  staticClass: "user--info",
                                  class: { hovered: _vm.userInfosHovered },
                                  on: {
                                    mouseover: _vm.handleMouseHover,
                                    mouseleave: _vm.handleMouseLeave
                                  }
                                },
                                [
                                  _vm.userInfosHovered &&
                                  _vm.$route.meta["edit_account_setting"]
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "user--info__edit",
                                          attrs: { type: "button" },
                                          on: { click: _vm.handleUpdateInfos }
                                        },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              attrs: {
                                                size: "55",
                                                color: "white"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    medium: "",
                                                    color: "black"
                                                  }
                                                },
                                                [_vm._v("edit")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("user-profile-enhanced-widget", {
                                    attrs: { user: _vm.userInfo }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { "mt-3": "" } }, [
                        _c("input", {
                          ref: "file",
                          staticStyle: { display: "none" },
                          attrs: {
                            type: "file",
                            id: "file",
                            accept: "image/png, image/jpeg"
                          },
                          on: {
                            change: function($event) {
                              _vm.handleFileUpload($event.target)
                            }
                          }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c(
                    "v-subheader",
                    { staticClass: "pl-0" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "ml-0": "", column: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("h1", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.lblSetting.notificationParameters
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "greyDark",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    {
                      attrs: { "pl-0": "", "pt-0": "", "pr-4": "", "mt-3": "" }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-list",
                            {
                              staticClass: "notifications--parameters",
                              attrs: { id: "notifications-parameters" }
                            },
                            [
                              _c(
                                "v-list-tile",
                                { attrs: { avatar: "" } },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "mr-3" },
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t(_vm.lblSetting.app))
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting
                                                .disableAppNotifications
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.notificationApp
                                            ? _vm.$t(_vm.lblSetting.enabled)
                                            : _vm.$t(_vm.lblSetting.disabled),
                                          disabled: !_vm.$route.meta[
                                            "edit_notification_setting"
                                          ]
                                        },
                                        on: {
                                          change: _vm.handleNotificationChange
                                        },
                                        model: {
                                          value: _vm.notificationApp,
                                          callback: function($$v) {
                                            _vm.notificationApp = $$v
                                          },
                                          expression: "notificationApp"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { attrs: { avatar: "" } },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t(_vm.lblSetting.email))
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting
                                                .disableEmailNotifications
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.notificationMail
                                            ? _vm.$t(_vm.lblSetting.enabled)
                                            : _vm.$t(_vm.lblSetting.disabled),
                                          disabled: !_vm.$route.meta[
                                            "edit_notification_setting"
                                          ]
                                        },
                                        on: {
                                          change: _vm.handleNotificationChange
                                        },
                                        model: {
                                          value: _vm.notificationMail,
                                          callback: function($$v) {
                                            _vm.notificationMail = $$v
                                          },
                                          expression: "notificationMail"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { attrs: { avatar: "" } },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t(_vm.lblSetting.sms))
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting
                                                .disableSmsNotifications
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.notificationSms
                                            ? _vm.$t(_vm.lblSetting.enabled)
                                            : _vm.$t(_vm.lblSetting.disabled),
                                          disabled: !_vm.$route.meta[
                                            "edit_notification_setting"
                                          ]
                                        },
                                        on: {
                                          change: _vm.handleNotificationChange
                                        },
                                        model: {
                                          value: _vm.notificationSms,
                                          callback: function($$v) {
                                            _vm.notificationSms = $$v
                                          },
                                          expression: "notificationSms"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("email-modification-modal", {
        attrs: {
          visible: _vm.dtEmailModificationModalVisible,
          email: _vm.userInfo.email
        },
        on: {
          "update:visible": function($event) {
            _vm.dtEmailModificationModalVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e4ef46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e4ef46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/profile-child-account/template.html
// module id = null
// module chunks = 